import axios from 'axios';
import API from '../config/config';

const adminAxios = axios.create({
  baseURL: API.BASE_URL
});

// Add auth token interceptor
adminAxios.interceptors.request.use(
  (config) => {
    const adminToken = localStorage.getItem('adminToken');
    if (adminToken) {
      config.headers.Authorization = `Bearer ${adminToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle token expiration
adminAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle token expiration but don't redirect immediately
      // This avoids potential redirect loops
      localStorage.removeItem('adminToken');
      localStorage.removeItem('admin');
    }
    return Promise.reject(error);
  }
);

export default adminAxios;
